import { LANG_CODES } from "@/i18n";

/**
 * Språkpreferens: lagras i localStorage ("lang") och – för inloggade
 * användare – även på kontot (user_metadata.preferred_lang) så att valet
 * följer med mellan mobil och dator.
 */
export const LANG_STORAGE_KEY = "lang";
export const LANG_SUGGEST_DISMISS_KEY = "lang-suggest-dismissed";

export function getStoredLang(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const v = window.localStorage.getItem(LANG_STORAGE_KEY);
    return v && LANG_CODES.includes(v) ? v : null;
  } catch {
    return null;
  }
}

export function setStoredLang(code: string) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(LANG_STORAGE_KEY, code);
  } catch {}
}

export function isSuggestionDismissed(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(LANG_SUGGEST_DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissSuggestion() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(LANG_SUGGEST_DISMISS_KEY, "1");
  } catch {}
}

/**
 * Läser webbläsarens språkinställningar och returnerar första stödda språket
 * som inte är svenska. Svenska är standard och behöver inget förslag.
 */
export function detectBrowserLang(): string | null {
  if (typeof window === "undefined") return null;
  const nav = window.navigator;
  const list: string[] = [
    ...(Array.isArray(nav?.languages) ? nav.languages : []),
    nav?.language ?? "",
  ].filter(Boolean);
  for (const raw of list) {
    const code = raw.toLowerCase().split("-")[0];
    if (code === "sv") return null; // svenska står först → inget förslag
    if (LANG_CODES.includes(code)) return code;
  }
  return null;
}

/** Sparar språkvalet på kontot när användaren är inloggad. */
export async function savePreferredLangToAccount(code: string) {
  if (typeof window === "undefined") return;
  try {
    const { supabase } = await import("@/integrations/supabase/client");
    const { data } = await supabase.auth.getSession();
    if (!data.session) return;
    if (data.session.user.user_metadata?.["preferred_lang"] === code) return;
    await supabase.auth.updateUser({ data: { preferred_lang: code } });
  } catch {}
}
